import { Card, ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

export default function TroubleshootingStepsCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix:
      'cameraConnectionIssue.cameraConnectionIssueModal.troubleshootingSteps',
  });

  return (
    <Card>
      <Card.Header
        className="small text-gray-400 fw-semibold text-uppercase"
        data-test="camera-connection-issue-troubleshooting-header"
      >
        {t('header')}
      </Card.Header>
      <ListGroup variant="flush">
        <ListGroup.Item>
          <span data-test="camera-connection-issue-troubleshooting-step">
            1. {t('checkPower')}
          </span>
        </ListGroup.Item>
        <ListGroup.Item>
          <span data-test="camera-connection-issue-troubleshooting-step">
            2. {t('checkCable')}
          </span>
        </ListGroup.Item>
        <ListGroup.Item>
          <span data-test="camera-connection-issue-troubleshooting-step">
            3. {t('checkBattery')}
          </span>
        </ListGroup.Item>
        <ListGroup.Item className="d-flex justify-content-between align-items-center">
          <span data-test="camera-connection-issue-troubleshooting-step">
            4. {t('restartCamera')}
          </span>
          <span
            className="text-gray-400 fst-italic small"
            data-test="camera-connection-issue-troubleshooting-restart-duration"
          >
            {t('restartCameraDuration')}
          </span>
        </ListGroup.Item>
      </ListGroup>
    </Card>
  );
}
